/**
 * Category Product Showcase — grid mode: collection order (sold out last only),
 * fixed page size (default 24). Uses /collections/{handle}/products.json (paginated fetch)
 * then rebuilds cards from a Liquid <template> prototype.
 */
(function () {
  var JSON_LIMIT = 250;
  var CACHE_PREFIX = 'skipp:cps-grid:v5:'; /* bump when sort / fetch logic changes */
  var CACHE_TTL_MS = 5 * 60 * 1000;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, limit, page) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      limit +
      '&page=' +
      page;
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function tagArray(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map(function (t) { return String(t).toLowerCase().trim(); });
    return String(tags)
      .split(',')
      .map(function (t) { return t.toLowerCase().trim(); })
      .filter(Boolean);
  }

  /** For optional delivery filter UI — explicit 30 min merch tags only (not express + city). */
  function deliveryFromTags(tags) {
    var t = tagArray(tags);
    if (t.indexOf('delivery_30min') !== -1 || t.indexOf('skipp_30min') !== -1 || t.indexOf('30min_delivery') !== -1) {
      return 'express';
    }
    if (
      t.indexOf('delivery_next_day') !== -1 ||
      t.indexOf('skipp_next_day') !== -1 ||
      t.indexOf('next_day_delivery') !== -1
    ) {
      return 'nextday';
    }
    return '';
  }

  function toCents(v) {
    if (v == null || v === '') return 0;
    var s = String(v).trim();
    if (s.indexOf('.') !== -1) return Math.round(parseFloat(s) * 100);
    var n = parseInt(s, 10);
    return isNaN(n) ? 0 : n;
  }

  function formatRs(cents) {
    if (!cents) return '0';
    return String(Math.round(cents / 100)).replace(/\.00$/, '');
  }

  /** Purchasable if any size/variant can be bought, or inventory exists / continue selling. */
  function variantIsPurchasable(v) {
    if (!v) return false;
    if (v.inventory_policy === 'continue') return true;
    var qty = v.inventory_quantity;
    if (qty != null && qty !== '' && Number(qty) > 0) return true;
    var a = v.available;
    if (a === true || a === 1) return true;
    if (typeof a === 'string') {
      var s = a.toLowerCase();
      if (s === 'true' || s === '1') return true;
      if (s === 'false' || s === '0') return false;
    }
    if (a === false || a === 0) return false;
    if (!v.inventory_management) return true;
    return false;
  }

  function productAvailable(p) {
    if (!p) return false;
    var vs = p.variants || [];
    var i;
    for (i = 0; i < vs.length; i++) {
      if (variantIsPurchasable(vs[i])) return true;
    }
    if (p.available === true || p.available === 1) return true;
    if (typeof p.available === 'string') {
      var a = p.available.toLowerCase();
      if (a === 'true' || a === '1') return true;
    }
    if (vs.length > 0) return false;
    if (p.available === false || p.available === 0) return false;
    return true;
  }

  function soldOutLabel() {
    var g = typeof window !== 'undefined' && window.__SKIPP_CPS_I18N__;
    return (g && g.soldOut) || 'Sold out';
  }

  function readCache(handle) {
    try {
      var raw = sessionStorage.getItem(CACHE_PREFIX + handle);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || !o.products) return null;
      if (Date.now() - o.t > CACHE_TTL_MS) return null;
      return o.products;
    } catch (_e) {
      return null;
    }
  }

  function writeCache(handle, products) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify({ t: Date.now(), products: products }));
    } catch (_e) {
      /* ignore quota */
    }
  }

  function fetchAllCollectionProducts(handle) {
    var cached = readCache(handle);
    if (cached) return Promise.resolve(cached);

    var all = [];
    var page = 1;

    function next() {
      var url = collectionProductsJsonUrl(handle, JSON_LIMIT, page);
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status + ' ' + url);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          for (var i = 0; i < batch.length; i++) {
            var p = batch[i];
            if (p) p.body_html = '';
            all.push(p);
          }
          if (batch.length < JSON_LIMIT) return all;
          page += 1;
          return next();
        });
    }

    return next().then(function (products) {
      writeCache(handle, products);
      return products;
    });
  }

  /**
   * Keep Shopify collection order from products.json; only move sold-out variants to the end.
   * No city / express / 30 min / serviceable reordering.
   */
  function sortCatalogForGrid(products) {
    var avail = [];
    var sold = [];
    for (var i = 0; i < products.length; i++) {
      if (productAvailable(products[i])) avail.push(products[i]);
      else sold.push(products[i]);
    }
    return avail.concat(sold);
  }

  function getPageFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search).get('page');
      var n = parseInt(p || '1', 10);
      if (isNaN(n) || n < 1) return 1;
      return n;
    } catch (_e) {
      return 1;
    }
  }

  function cpsBrandParamKey(sectionId) {
    return 'cps_brand_' + String(sectionId || '').trim();
  }

  function normalizeVendor(v) {
    return String(v || '').trim().toLowerCase();
  }

  function normalizeBrandList(brands) {
    if (brands == null) return [];
    if (typeof brands === 'string') {
      if (!brands.trim()) return [];
      return brands
        .split(',')
        .map(function (s) {
          return String(s || '').trim();
        })
        .filter(Boolean);
    }
    if (!Array.isArray(brands)) return [];
    return brands
      .map(function (s) {
        return String(s || '').trim();
      })
      .filter(Boolean);
  }

  function getCpsBrandsFromUrl(sectionId) {
    try {
      var key = cpsBrandParamKey(sectionId);
      var params = new URLSearchParams(window.location.search);
      var all = params.getAll(key);
      if (!all.length) {
        var single = (params.get(key) || '').trim();
        if (!single) return [];
        return normalizeBrandList(single);
      }
      return all
        .map(function (s) {
          return String(s || '').trim();
        })
        .filter(Boolean);
    } catch (_e) {
      return [];
    }
  }

  function brandMatchesSelection(vendor, brands) {
    var list = normalizeBrandList(brands);
    if (!list.length) return true;
    var v = normalizeVendor(vendor);
    for (var i = 0; i < list.length; i++) {
      if (normalizeVendor(list[i]) === v) return true;
    }
    return false;
  }

  function toggleBrandInList(brands, label) {
    var list = normalizeBrandList(brands).slice();
    var target = normalizeVendor(label);
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (normalizeVendor(list[i]) === target) {
        idx = i;
        break;
      }
    }
    if (idx >= 0) list.splice(idx, 1);
    else if (label) list.push(label);
    return list;
  }

  function applyCpsBrandsToUrlParams(q, sectionId, brands) {
    var brandKey = cpsBrandParamKey(sectionId);
    q.delete(brandKey);
    normalizeBrandList(brands).forEach(function (b) {
      q.append(brandKey, b);
    });
  }

  function readCpsPanelBrands(panel) {
    if (!panel) return [];
    try {
      return normalizeBrandList(JSON.parse(panel.getAttribute('data-cps-active-brands') || '[]'));
    } catch (_e) {
      return [];
    }
  }

  function filterProductsByBrand(products, brands) {
    var list = normalizeBrandList(brands);
    if (!list.length) return products;
    return products.filter(function (p) {
      return brandMatchesSelection(p && p.vendor, list);
    });
  }

  function getCpsDisplayProducts(gridWrap) {
    var list = gridWrap._cpsSortedProducts || [];
    var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var brands = gridWrap._cpsBrandFilter;
    if (brands === undefined) brands = getCpsBrandsFromUrl(sectionId);
    return filterProductsByBrand(list, brands);
  }

  function syncCpsBrandFilterUi(sectionEl, brands, scopeEl) {
    var root = scopeEl || sectionEl;
    if (!root) return;
    var selected = {};
    normalizeBrandList(brands).forEach(function (b) {
      selected[normalizeVendor(b)] = true;
    });
    root.querySelectorAll('[data-cps-brand-filter]').forEach(function (btn) {
      var label = btn.getAttribute('data-cps-brand-filter') || '';
      var on = !!selected[normalizeVendor(label)];
      btn.classList.toggle('skipp-plp-brand-filter__chip--active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    reorderCpsBrandFilterChips(root, brands);
  }

  function reorderCpsBrandFilterChips(scopeEl, brands) {
    if (!scopeEl) return;
    var selectedOrder = {};
    normalizeBrandList(brands).forEach(function (b, i) {
      selectedOrder[normalizeVendor(b)] = i;
    });

    function sortItems(items) {
      var active = [];
      var inactive = [];
      items.forEach(function (item) {
        var btn = item.querySelector('[data-cps-brand-filter]');
        var label = btn ? btn.getAttribute('data-cps-brand-filter') || '' : '';
        var key = normalizeVendor(label);
        if (Object.prototype.hasOwnProperty.call(selectedOrder, key)) {
          active.push({ item: item, order: selectedOrder[key] });
        } else {
          inactive.push(item);
        }
      });
      active.sort(function (a, b) {
        return a.order - b.order;
      });
      return active
        .map(function (x) {
          return x.item;
        })
        .concat(inactive);
    }

    scopeEl.querySelectorAll('.skipp-plp-brand-filter__list--desktop').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.skipp-plp-brand-filter__item'));
      if (!items.length) return;
      sortItems(items).forEach(function (item) {
        list.appendChild(item);
      });
    });

    scopeEl.querySelectorAll('.skipp-plp-brand-filter__rows').forEach(function (rowsWrap) {
      var rowLists = Array.prototype.slice.call(rowsWrap.querySelectorAll('.skipp-plp-brand-filter__list--row'));
      if (!rowLists.length) return;
      var allItems = [];
      rowLists.forEach(function (list) {
        allItems = allItems.concat(Array.prototype.slice.call(list.querySelectorAll('.skipp-plp-brand-filter__item')));
      });
      if (!allItems.length) return;
      var sorted = sortItems(allItems);
      rowLists.forEach(function (list) {
        list.innerHTML = '';
      });
      sorted.forEach(function (item, index) {
        var targetRow = rowLists[index % rowLists.length] || rowLists[0];
        targetRow.appendChild(item);
      });
    });

    if (normalizeBrandList(brands).length) {
      var scroll = scopeEl.querySelector('.skipp-plp-brand-filter__scroll');
      if (scroll) scroll.scrollLeft = 0;
    }
  }

  function readCpsBrandFilterMap(sectionEl) {
    var mapEl = sectionEl.querySelector('script[type="application/json"][data-cps-brand-filter-map]');
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent || '{}');
    } catch (_e) {
      return null;
    }
  }

  function swapCpsBrandFilterHtml(sectionEl, blockId) {
    var host = sectionEl.querySelector('[data-cps-brand-filter-host]');
    if (!host) return;
    var map = readCpsBrandFilterMap(sectionEl);
    if (!map || !map[blockId]) {
      host.innerHTML = '';
      syncCpsBrandFilterUi(sectionEl, [], host);
      return;
    }
    host.innerHTML = map[blockId];
    syncCpsBrandFilterUi(sectionEl, [], host);
  }

  function pushCpsGridUrlState(sectionEl, gridWrap, brands, resetPage) {
    var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var qpKey = gridWrap.getAttribute('data-cps-qp-key') || sectionEl.getAttribute('data-cps-qp-key') || '';
    var panelId = gridWrap.getAttribute('data-cps-block-id') || '';
    var q = new URLSearchParams(window.location.search);
    applyCpsBrandsToUrlParams(q, sectionId, brands);
    if (resetPage) q.delete('page');
    if (qpKey && panelId) q.set(qpKey, panelId);
    try {
      history.pushState({ skippCpsGrid: true }, '', window.location.pathname + (q.toString() ? '?' + q.toString() : '') + window.location.hash);
    } catch (_e) {}
  }

  function bindCpsBrandFilter(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cpsBrandFilterBound === '1') return;
    sectionEl.dataset.cpsBrandFilterBound = '1';

    sectionEl.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[data-cps-brand-filter]');
        if (!btn || !sectionEl.contains(btn)) return;

        var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
        if (grid) {
          e.preventDefault();
          var sectionId = grid.getAttribute('data-cps-section-internal-id') || '';
          var label = btn.getAttribute('data-cps-brand-filter') || '';
          var current = grid._cpsBrandFilter;
          if (current === undefined) current = getCpsBrandsFromUrl(sectionId);
          var next = toggleBrandInList(current, label);
          grid._cpsBrandFilter = next;
          syncCpsBrandFilterUi(sectionEl, next, sectionEl.querySelector('[data-cps-brand-filter-host]') || sectionEl);
          pushCpsGridUrlState(sectionEl, grid, next, true);
          grid.removeAttribute('data-cps-sort-in-flight');
          if (tryApplyCpsGridPageOnly(grid)) return;
          runSortForWrap(grid);
          return;
        }

        var panel = btn.closest('[data-cps-panel]');
        if (!panel) return;
        e.preventDefault();
        var brandLabel = btn.getAttribute('data-cps-brand-filter') || '';
        var nextBrands = toggleBrandInList(readCpsPanelBrands(panel), brandLabel);
        panel.setAttribute('data-cps-active-brands', JSON.stringify(nextBrands));
        syncCpsBrandFilterUi(sectionEl, nextBrands, panel);
        panel.querySelectorAll('.category-product-showcase__slide[data-vendor]').forEach(function (slide) {
          var vendor = slide.getAttribute('data-vendor') || '';
          if (!nextBrands.length) {
            slide.style.removeProperty('display');
          } else {
            slide.style.display = brandMatchesSelection(vendor, nextBrands) ? '' : 'none';
          }
        });
      },
      false
    );
  }

  function replaceProtoIds(root, protoId, newId) {
    var a = String(protoId);
    var b = String(newId);
    if (a === b) return;
    root.querySelectorAll('[id]').forEach(function (el) {
      if (el.id.indexOf(a) !== -1) el.id = el.id.split(a).join(b);
    });
    ['aria-labelledby', 'for', 'aria-controls', 'data-modal', 'data-product-url'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var v = el.getAttribute(attr);
        if (v && v.indexOf(a) !== -1) el.setAttribute(attr, v.split(a).join(b));
      });
    });
  }

  function updateProductLinks(root, handle) {
    var path = '/products/' + encodeURIComponent(handle);
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1) return;
      try {
        a.setAttribute('href', path + (href.indexOf('?') !== -1 ? href.slice(href.indexOf('?')) : ''));
      } catch (_e) {
        a.setAttribute('href', path);
      }
    });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function exclusiveBrandLabel(vendorName, product) {
    var key = String(vendorName || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    if (
      key === 'cop underdog' ||
      key === 'street junkies' ||
      key === 'lords and kings' ||
      key === 'lords & kings'
    ) {
      return 'Exclusive brand';
    }
    if (
      document.body &&
      (document.body.classList.contains('skipp-luxury-visual') ||
        document.body.classList.contains('luxury-mode'))
    ) {
      return 'Exclusive brand';
    }
    if (document.querySelector && document.querySelector('.modern-header--lux-only')) {
      return 'Exclusive brand';
    }
    var tags = (product && product.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === 'luxury') return 'Exclusive brand';
    }
    if (product && (product.template_suffix === 'luxury' || product.templateSuffix === 'luxury')) {
      return 'Exclusive brand';
    }
    return String(vendorName || '').trim();
  }

  function updateVendor(root, vendorName, product) {
    var wrap = root.querySelector('.card-vendor');
    if (!wrap) return;
    var v = exclusiveBrandLabel(vendorName, product);
    wrap.innerHTML =
      '<div class="card-vendor">' +
      '<span class="card-vendor__name">' +
      escapeHtml(v) +
      '</span></div>';
  }

  function cleanupProtoNoise(article) {
    article.querySelectorAll('.rating, .rating-text, .rating-count').forEach(function (el) {
      el.remove();
    });
    var cap = article.querySelector('.card-information .caption-large.light');
    if (cap) cap.textContent = '';
  }

  function updateTitle(root, title) {
    root.querySelectorAll('.card__heading a').forEach(function (el) {
      el.textContent = title;
    });
    var cover = root.querySelector('.skipp-card-full-cover-link .visually-hidden');
    if (cover) cover.textContent = title;
  }

  function updateWishlistButton(root, product) {
    var btn = root.querySelector('.product-wishlist');
    if (!btn || !product) return;
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var img = featuredImageUrl(product);
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    btn.setAttribute('data-product-id', String(product.id));
    btn.setAttribute('data-product-handle', product.handle || '');
    btn.setAttribute('data-product-title', product.title || '');
    btn.setAttribute('data-product-vendor', product.vendor || '');
    btn.setAttribute('data-product-img', img);
    btn.setAttribute('data-product-price', '₹' + formatRs(cents));
    btn.setAttribute('data-product-url', '/products/' + encodeURIComponent(product.handle || ''));
    if (window.onhowWishlist && typeof window.onhowWishlist.syncButtonState === 'function') {
      window.onhowWishlist.syncButtonState(btn);
    }
  }

  function featuredImageUrl(product) {
    var fi = product.featured_image;
    if (typeof fi === 'string' && fi) return fi;
    if (fi && typeof fi === 'object' && fi.src) return fi.src;
    var imgs = product.images;
    if (!imgs || !imgs.length) return '';
    var first = imgs[0];
    if (typeof first === 'string') return first;
    if (first && typeof first === 'object' && first.src) return first.src;
    return '';
  }

  /** Request a sharper CDN width when client-sort swaps images (proto uses 533w). */
  function sizedProductImageUrl(url, width) {
    if (!url || !width) return url;
    var w = Math.max(360, Math.min(1066, Math.round(width)));
    try {
      if (/[?&]width=\d+/i.test(url)) {
        return url.replace(/([?&])width=\d+/i, '$1width=' + w);
      }
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    } catch (_e) {
      return url;
    }
  }

  function updateFeaturedImage(root, product) {
    var url = featuredImageUrl(product);
    if (!url) return;
    var imgs = root.querySelectorAll('.card__media img');
    if (imgs[0]) {
      var tileW = 0;
      try {
        tileW = root.getBoundingClientRect().width;
      } catch (_e) {}
      var targetW = tileW > 0 ? Math.ceil(tileW * 2) : 720;
      imgs[0].src = sizedProductImageUrl(url, targetW);
      imgs[0].removeAttribute('srcset');
      imgs[0].removeAttribute('width');
      imgs[0].removeAttribute('height');
      imgs[0].sizes = '';
      imgs[0].style.width = '100%';
      imgs[0].style.height = '100%';
      imgs[0].style.objectFit = 'cover';
      imgs[0].style.objectPosition = 'center top';
    }
  }

  function isSkippTagged(product, tagName) {
    var t = tagArray(product.tags);
    return t.indexOf(String(tagName || 'From_249').toLowerCase()) !== -1;
  }

  function applyStandardPrice(root, product) {
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;
    var av = productAvailable(product);
    var priceEl = root.querySelector('.price');
    if (!priceEl) return;

    var sym = '₹';
    priceEl.classList.toggle('price--sold-out', !av);
    priceEl.classList.toggle('price--on-sale', av && compareCents > cents);

    if (!av) {
      priceEl.innerHTML =
        '<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">' +
        sym +
        formatRs(cents) +
        '</span></div></div>';
      return;
    }
    if (compareCents > cents) {
      priceEl.innerHTML =
        '<div class="price__container"><div class="price__sale"><span class="visually-hidden visually-hidden--inline">Sale price</span><span class="price-item price-item--sale price-item--last price-final">' +
        sym +
        formatRs(cents) +
        '</span><span><s class="price-item price-item--regular price-compare">' +
        sym +
        formatRs(compareCents) +
        '</s></span></div></div>';
      return;
    }
    priceEl.innerHTML =
      '<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span><span class="price-item price-item--regular">' +
      sym +
      formatRs(cents) +
      '</span></div></div>';
  }

  function applySkippCardPrice(root, product, showSkipp, skippTag) {
    var priceBlock = root.querySelector('[data-skipp-card-price]');
    if (!priceBlock) {
      applyStandardPrice(root, product);
      return;
    }

    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;
    var sym = '₹';

    var currentEl = priceBlock.querySelector('.skipp-card-price__current');
    var compareEl = priceBlock.querySelector('.skipp-card-price__compare');
    var discountEl = priceBlock.querySelector('.skipp-card-price__discount');
    var offerEl = priceBlock.querySelector('.skipp-card-offer');

    if (currentEl) currentEl.textContent = sym + formatRs(cents);

    if (compareEl) {
      if (productAvailable(product) && compareCents > cents) {
        compareEl.textContent = sym + formatRs(compareCents);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (discountEl) {
      if (productAvailable(product) && compareCents > cents) {
        var pct = Math.round(((compareCents - cents) * 100) / compareCents);
        discountEl.textContent = '(' + pct + '% OFF)';
        discountEl.setAttribute('aria-label', pct + ' percent off');
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }

    if (offerEl) {
      if (showSkipp && isSkippTagged(product, skippTag) && productAvailable(product)) {
        var skippCents = Math.max(0, cents - 20000);
        offerEl.textContent = 'Get it for ' + sym + formatRs(skippCents) + ' with coupon';
        offerEl.hidden = false;
      } else {
        offerEl.hidden = true;
      }
    }
  }

  function applyPricing(root, product, showSkipp, skippTag) {
    applySkippCardPrice(root, product, showSkipp, skippTag);
  }

  function applySoldOutVisuals(root, product) {
    var av = productAvailable(product);
    root.querySelectorAll('.card').forEach(function (card) {
      card.classList.toggle('card--sold-out', !av);
    });
    var wrap = root.querySelector('.card-wrapper, .product-card-wrapper');
    if (wrap) {
      wrap.classList.toggle('product-card-wrapper--sold-out', !av);
      wrap.setAttribute('data-skipp-in-stock', av ? 'true' : 'false');
    }
    root.classList.toggle('category-product-showcase__slide--sold-out', !av);
    root.querySelectorAll('.price').forEach(function (priceEl) {
      priceEl.classList.toggle('price--sold-out', !av);
    });
  }

  function applyCardBadge(root, product, soldClass) {
    var wraps = root.querySelectorAll('.card__badge');
    if (!wraps.length) return;

    var av = productAvailable(product);
    var scheme = soldClass || '';

    function setAllBadges(html) {
      for (var w = 0; w < wraps.length; w++) {
        wraps[w].innerHTML = html;
      }
    }

    if (!av) {
      setAllBadges(
        '<span class="badge badge--bottom-left ' +
          scheme +
          '">' +
          soldOutLabel() +
          '</span>'
      );
      return;
    }
    setAllBadges('');
  }

  function updateDiscountInline(root, product) {
    var priceRow = root.querySelector('.price-row');
    if (!priceRow) return;

    var tag = priceRow.querySelector('.discount-inline');
    var v = (product.variants && product.variants[0]) || {};
    var cents = toCents(v.price);
    var compareCents = v.compare_at_price != null ? toCents(v.compare_at_price) : 0;

    if (!productAvailable(product) || compareCents <= cents) {
      if (tag) tag.remove();
      return;
    }

    var pct = Math.round(((compareCents - cents) * 100) / compareCents);
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'discount-inline';
      priceRow.appendChild(tag);
    }
    tag.setAttribute('aria-label', pct + '% off');
    tag.textContent = '-' + pct + '%';
  }

  function buildArticleFromProduct(product, protoTemplate, protoId, cardCfg) {
    var node = protoTemplate.content.cloneNode(true);
    var article = node.querySelector('article.category-product-showcase__slide--grid');
    if (!article) return null;

    cleanupProtoNoise(article);

    var tagsStr = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
    article.setAttribute('data-delivery', deliveryFromTags(tagsStr));
    article.setAttribute('data-skipp-product-title', product.title || '');
    article.setAttribute('data-skipp-tags', tagsStr);
    article.setAttribute('data-vendor', product.vendor || '');

    replaceProtoIds(article, protoId, product.id);
    updateProductLinks(article, product.handle);
    updateTitle(article, product.title || '');
    updateVendor(article, product.vendor, product);
    updateFeaturedImage(article, product);
    updateWishlistButton(article, product);

    applyPricing(article, product, cardCfg.showSkipp, cardCfg.skippTag);
    applyCardBadge(article, product, cardCfg.soldBadgeClass);
    applySoldOutVisuals(article, product);

    var tagWrap = article.querySelector('.card-wrapper[data-skipp-tags]');
    if (tagWrap) tagWrap.setAttribute('data-skipp-tags', tagsStr);

    return article;
  }

  function updateGridRange(gridWrap, start, end, total) {
    var el = gridWrap.querySelector('.category-product-showcase__grid-range');
    if (!el) return;
    el.textContent = 'Showing ' + start + '–' + end + ' of ' + total + ' products';
  }

  function findProto(sectionId, blockId) {
    var bySection = document.getElementById('cps-card-proto-' + sectionId);
    if (bySection) return bySection;
    var id = 'cps-card-proto-' + sectionId + '-' + blockId;
    var el = document.getElementById(id);
    if (el) return el;
    var prefix = 'cps-card-proto-' + sectionId + '-';
    var all = document.querySelectorAll('template[id^="' + prefix + '"]');
    if (all.length === 1) return all[0];
    return null;
  }

  /**
   * When Liquid cannot read the tab query param (pageurl), SSR may use the wrong collection while the
   * browser URL is correct. Align grid handle + tab UI from location.search before fetching products.json.
   */
  function alignCpsGridWithUrl() {
    document.querySelectorAll('[data-category-product-showcase]').forEach(function (sectionEl) {
      var qpKey = sectionEl.getAttribute('data-cps-qp-key');
      if (!qpKey || sectionEl.getAttribute('data-cps-product-mode') !== 'grid') return;
      var mapEl = sectionEl.querySelector('script[type="application/json"][data-cps-tab-handles]');
      if (!mapEl) return;
      var map;
      try {
        map = JSON.parse(mapEl.textContent || '{}');
      } catch (_e) {
        return;
      }
      var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
      if (!grid) return;

      var params = new URLSearchParams(window.location.search);
      var fromUrl = (params.get(qpKey) || '').trim();

      if (!fromUrl) {
        grid.dataset.cpsUrlAligned = '1';
        return;
      }

      var handle = map[fromUrl];
      if (!handle) return;

      var serverBlock = (grid.getAttribute('data-cps-block-id') || '').trim();
      if (fromUrl === serverBlock) {
        grid.dataset.cpsUrlAligned = '1';
        return;
      }

      grid.setAttribute('data-cps-block-id', fromUrl);
      grid.setAttribute('data-cps-collection-handle', handle);
      grid.dataset.cpsUrlAligned = '1';
      sectionEl.querySelectorAll('a.category-product-showcase__tab').forEach(function (tab) {
        var tid = (tab.getAttribute('data-cps-tab') || '').trim();
        var on = tid === fromUrl;
        tab.classList.toggle('active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var panel = sectionEl.querySelector('.category-product-showcase__panel[data-cps-panel]');
      if (panel) {
        var sid = sectionEl.getAttribute('data-category-product-showcase') || '';
        panel.setAttribute('data-cps-panel', fromUrl);
        if (sid) panel.setAttribute('aria-labelledby', 'tab-' + sid + '-' + fromUrl);
      }
    });
  }

  function scrollCpsShowcaseSectionIntoView(gridWrap) {
    var sid = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var el =
      (sid && document.getElementById('CategoryProductShowcase-' + sid)) ||
      gridWrap.closest('section.category-product-showcase');
    if (!el) return;
    try {
      el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } catch (_e) {
      try {
        el.scrollIntoView(true);
      } catch (_e2) {}
    }
  }

  function maybeScrollCpsAfterPagination(gridWrap) {
    if (!gridWrap || gridWrap.dataset.cpsScrollAfterPagination !== '1') return;
    delete gridWrap.dataset.cpsScrollAfterPagination;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollCpsShowcaseSectionIntoView(gridWrap);
      });
    });
  }

  function ensureCpsPaginationRoot(gridWrap) {
    var root = gridWrap.querySelector('.category-product-showcase__pagination');
    if (root) return root;
    root = document.createElement('div');
    root.className = 'category-product-showcase__pagination';
    root.setAttribute('data-cps-pagination-root', '');
    gridWrap.appendChild(root);
    return root;
  }

  function buildCpsPaginationItems(curPage, pages) {
    if (pages <= 7) {
      var all = [];
      for (var i = 1; i <= pages; i++) all.push(i);
      return all;
    }

    var items = [];
    var tailStart = pages - 2;

    if (curPage <= 4) {
      for (var a = 1; a <= 5; a++) items.push(a);
      if (tailStart > 6) {
        items.push('ellipsis');
        for (var b = tailStart; b <= pages; b++) items.push(b);
      } else {
        for (var c = 6; c <= pages; c++) items.push(c);
      }
      return items;
    }

    if (curPage >= pages - 3) {
      items.push(1);
      items.push('ellipsis');
      for (var d = pages - 4; d <= pages; d++) items.push(d);
      return items;
    }

    items.push(1);
    items.push('ellipsis');
    for (var e = curPage - 1; e <= curPage + 1; e++) items.push(e);
    items.push('ellipsis');
    for (var f = tailStart; f <= pages; f++) items.push(f);
    return items;
  }

  function getCpsGridCardsEl(gridWrap) {
    return gridWrap.querySelector('[data-cps-grid-cards]');
  }

  function clearCpsGridCardNodes(cardsEl) {
    if (!cardsEl) return;
    cardsEl.querySelectorAll('article.category-product-showcase__slide--grid').forEach(function (n) {
      n.remove();
    });
  }

  function clearCpsGridSortedMemory(gridWrap) {
    delete gridWrap._cpsSortedProducts;
    delete gridWrap._cpsSortedHandle;
  }

  /**
   * Same collection: paging only (no fetch, no resort) — instant.
   */
  function tryApplyCpsGridPageOnly(gridWrap) {
    var handle = (gridWrap.getAttribute('data-cps-collection-handle') || '').trim();
    var list = gridWrap._cpsSortedProducts;
    if (!list || !list.length || gridWrap._cpsSortedHandle !== handle) {
      return false;
    }

    list = getCpsDisplayProducts(gridWrap);

    var cardsEl = getCpsGridCardsEl(gridWrap);
    if (!cardsEl) return false;

    var blockId = gridWrap.getAttribute('data-cps-block-id') || '';
    var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var proto = findProto(sectionId, blockId);
    if (!proto || !proto.getAttribute('data-cps-proto-product-id')) return false;

    var perPage = parseInt(gridWrap.getAttribute('data-cps-per-page') || '24', 10) || 24;
    var page = getPageFromUrl();
    var pages = Math.max(1, Math.ceil(list.length / perPage));
    if (page > pages) page = pages;
    var startIdx = (page - 1) * perPage;
    var slice = list.slice(startIdx, startIdx + perPage);

    var protoId = proto.getAttribute('data-cps-proto-product-id');
    var skippTag = gridWrap.getAttribute('data-cps-skipp-pricing-tag') || 'From_249';
    var showSkipp = gridWrap.getAttribute('data-cps-show-skipp-price') === 'true';
    var soldBadgeClass = gridWrap.getAttribute('data-cps-sold-badge-class') || '';
    var saleBadgeClass = gridWrap.getAttribute('data-cps-sale-badge-class') || '';

    clearCpsGridCardNodes(cardsEl);

    var cardCfg = {
      skippTag: skippTag,
      showSkipp: showSkipp,
      soldBadgeClass: soldBadgeClass,
      saleBadgeClass: saleBadgeClass,
    };
    for (var i = 0; i < slice.length; i++) {
      var art = buildArticleFromProduct(slice[i], proto, protoId, cardCfg);
      if (art) cardsEl.appendChild(art);
    }

    var total = list.length;
    var lo = total === 0 ? 0 : startIdx + 1;
    var hi = Math.min(startIdx + perPage, total);
    updateGridRange(gridWrap, lo, hi, total);
    rebuildCpsPagination(gridWrap, total, perPage);

    document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));

    return true;
  }

  function rebuildCpsPagination(gridWrap, total, perPage) {
    var root = ensureCpsPaginationRoot(gridWrap);
    var qpKey = gridWrap.getAttribute('data-cps-qp-key') || '';
    var panelId = gridWrap.getAttribute('data-cps-block-id') || '';
    var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var pages = Math.max(1, Math.ceil(total / perPage));
    var curPage = getPageFromUrl();
    if (curPage > pages) curPage = pages;

    function hrefFor(p) {
      var q = new URLSearchParams(window.location.search);
      if (p <= 1) q.delete('page');
      else q.set('page', String(p));
      if (qpKey && panelId) q.set(qpKey, panelId);
      var brands = gridWrap._cpsBrandFilter;
      if (brands === undefined) brands = getCpsBrandsFromUrl(sectionId);
      applyCpsBrandsToUrlParams(q, sectionId, brands);
      var s = q.toString();
      return window.location.pathname + (s ? '?' + s : '');
    }

    if (pages <= 1) {
      root.innerHTML = '';
      return;
    }

    var html =
      '<div class="pagination-wrapper" data-page="' +
      curPage +
      '"><nav class="pagination" role="navigation" aria-label="Pagination"><ul class="pagination__list list-unstyled" role="list">';

    if (curPage > 1) {
      html +=
        '<li><a href="' +
        escapeHtml(hrefFor(curPage - 1)) +
        '" class="pagination__item pagination__item-arrow pagination__item--arrow-prev link motion-reduce" rel="prev" aria-label="Previous"><span class="pagination__item-arrow__glyph" aria-hidden="true">&lsaquo;</span></a></li>';
    }

    buildCpsPaginationItems(curPage, pages).forEach(function (item) {
      if (item === 'ellipsis') {
        html += '<li><span class="pagination__item pagination__item--ellipsis" aria-hidden="true">&hellip;</span></li>';
        return;
      }
      if (item === curPage) {
        html +=
          '<li><span class="pagination__item pagination__item--current" aria-current="page">' +
          item +
          '</span></li>';
      } else {
        html +=
          '<li><a href="' +
          escapeHtml(hrefFor(item)) +
          '" class="pagination__item link" aria-label="Page ' +
          item +
          '">' +
          item +
          '</a></li>';
      }
    });

    if (curPage < pages) {
      html +=
        '<li><a href="' +
        escapeHtml(hrefFor(curPage + 1)) +
        '" class="pagination__item pagination__item-arrow pagination__item--arrow-next link motion-reduce" rel="next" aria-label="Next"><span class="pagination__item-arrow__glyph" aria-hidden="true">&rsaquo;</span></a></li>';
    }

    html += '</ul></nav></div>';
    root.innerHTML = html;
  }

  function setGridLoadingState(gridWrap, cardsEl, loading) {
    if (!gridWrap) return;
    if (loading) {
      gridWrap.setAttribute('data-cps-loading', 'true');
      if (cardsEl) cardsEl.classList.add('category-product-showcase__grid-cards--cps-loading');
      var panel = gridWrap.closest('.category-product-showcase__panel');
      if (panel) panel.setAttribute('aria-busy', 'true');
    } else {
      gridWrap.removeAttribute('data-cps-loading');
      if (cardsEl) cardsEl.classList.remove('category-product-showcase__grid-cards--cps-loading');
      var panelEl = gridWrap.closest('.category-product-showcase__panel');
      if (panelEl) panelEl.removeAttribute('aria-busy');
    }
  }

  function runSortForWrap(gridWrap) {
    if (gridWrap.getAttribute('data-cps-client-sort') !== 'true') return;
    if (gridWrap.dataset.cpsSortInFlight === '1') return;

    var handle = (gridWrap.getAttribute('data-cps-collection-handle') || '').trim();
    var blockId = gridWrap.getAttribute('data-cps-block-id') || '';
    var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
    var cardsEl = getCpsGridCardsEl(gridWrap);
    if (!handle || !cardsEl) return;

    var proto = findProto(sectionId, blockId);
    if (!proto || !proto.getAttribute('data-cps-proto-product-id')) return;

    clearCpsGridSortedMemory(gridWrap);
    gridWrap.dataset.cpsSortInFlight = '1';

    var protoId = proto.getAttribute('data-cps-proto-product-id');
    var perPage = parseInt(gridWrap.getAttribute('data-cps-per-page') || '24', 10) || 24;
    var skippTag = gridWrap.getAttribute('data-cps-skipp-pricing-tag') || 'From_249';
    var showSkipp = gridWrap.getAttribute('data-cps-show-skipp-price') === 'true';
    var soldBadgeClass = gridWrap.getAttribute('data-cps-sold-badge-class') || '';
    var saleBadgeClass = gridWrap.getAttribute('data-cps-sale-badge-class') || '';

    var handleAtFetch = handle;
    if (!cardsEl.querySelector('article, .grid__item, .product-card-wrapper')) {
      setGridLoadingState(gridWrap, cardsEl, true);
    }

    fetchAllCollectionProducts(handle)
      .then(function (products) {
        var currentHandle = (gridWrap.getAttribute('data-cps-collection-handle') || '').trim();
        if (currentHandle !== handleAtFetch) {
          delete gridWrap.dataset.cpsScrollAfterPagination;
          return;
        }

        if (!products || products.length === 0) {
          clearCpsGridCardNodes(cardsEl);
          updateGridRange(gridWrap, 0, 0, 0);
          rebuildCpsPagination(gridWrap, 0, perPage);
          maybeScrollCpsAfterPagination(gridWrap);
          return;
        }

        var sorted = sortCatalogForGrid(products);
        var sectionId = gridWrap.getAttribute('data-cps-section-internal-id') || '';
        var brands = getCpsBrandsFromUrl(sectionId);
        gridWrap._cpsBrandFilter = brands;
        var sec = gridWrap.closest('[data-category-product-showcase]');
        if (sec) {
          var brandHost = sec.querySelector('[data-cps-brand-filter-host]');
          syncCpsBrandFilterUi(sec, brands, brandHost || sec);
        }

        var display = filterProductsByBrand(sorted, brands);
        var page = getPageFromUrl();
        var pages = Math.max(1, Math.ceil(display.length / perPage));
        if (page > pages) page = pages;
        var startIdx = (page - 1) * perPage;
        var slice = display.slice(startIdx, startIdx + perPage);
        clearCpsGridCardNodes(cardsEl);

        var cardCfg = {
          skippTag: skippTag,
          showSkipp: showSkipp,
          soldBadgeClass: soldBadgeClass,
          saleBadgeClass: saleBadgeClass,
        };

        for (var i = 0; i < slice.length; i++) {
          var art = buildArticleFromProduct(slice[i], proto, protoId, cardCfg);
          if (art) cardsEl.appendChild(art);
        }

        var total = display.length;
        var lo = total === 0 ? 0 : startIdx + 1;
        var hi = Math.min(startIdx + perPage, total);
        updateGridRange(gridWrap, lo, hi, total);
        rebuildCpsPagination(gridWrap, total, perPage);

        gridWrap._cpsSortedProducts = sorted;
        gridWrap._cpsSortedHandle = handleAtFetch;

        gridWrap.dataset.cpsClientSortDone = '1';

        document.dispatchEvent(new CustomEvent('skipp:user-location-changed'));
        maybeScrollCpsAfterPagination(gridWrap);
      })
      .catch(function () {
        delete gridWrap.dataset.cpsScrollAfterPagination;
      })
      .finally(function () {
        var currentHandle = (gridWrap.getAttribute('data-cps-collection-handle') || '').trim();
        if (currentHandle !== handleAtFetch) {
          delete gridWrap.dataset.cpsScrollAfterPagination;
          return;
        }
        setGridLoadingState(gridWrap, cardsEl, false);
        gridWrap.removeAttribute('data-cps-sort-in-flight');
      });
  }

  /**
   * Switch category tab without full page reload (grid mode). Updates URL with history.pushState
   * so the address bar stays shareable; product area refetches via products.json only.
   */
  function switchCpsGridCollection(sectionEl, blockId, updateHistory) {
    if (updateHistory === undefined) updateHistory = true;
    var qpKey = sectionEl.getAttribute('data-cps-qp-key');
    if (!qpKey) return;

    var mapEl = sectionEl.querySelector('script[type="application/json"][data-cps-tab-handles]');
    if (!mapEl) return;
    var map;
    try {
      map = JSON.parse(mapEl.textContent || '{}');
    } catch (_e) {
      return;
    }
    var handle = map[blockId];
    if (!handle) return;

    var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
    if (!grid) return;

    var sid = sectionEl.getAttribute('data-category-product-showcase') || '';

    grid.removeAttribute('data-cps-sort-in-flight');
    grid.setAttribute('data-cps-block-id', blockId);
    grid.setAttribute('data-cps-collection-handle', handle);
    grid.dataset.cpsUrlAligned = '1';
    delete grid.dataset.cpsClientSortDone;
    grid._cpsBrandFilter = [];
    swapCpsBrandFilterHtml(sectionEl, blockId);

    clearCpsGridSortedMemory(grid);
    clearCpsGridCardNodes(getCpsGridCardsEl(grid));

    sectionEl.querySelectorAll('a.category-product-showcase__tab[data-cps-tab]').forEach(function (tab) {
      var tid = (tab.getAttribute('data-cps-tab') || '').trim();
      var on = tid === blockId;
      tab.classList.toggle('active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    var panel = sectionEl.querySelector('.category-product-showcase__panel[data-cps-panel]');
    if (panel) {
      panel.setAttribute('data-cps-panel', blockId);
      if (sid) panel.setAttribute('aria-labelledby', 'tab-' + sid + '-' + blockId);
    }

    if (updateHistory) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.set(qpKey, blockId);
        u.searchParams.delete('page');
        u.searchParams.delete(cpsBrandParamKey(sid));
        history.pushState({ skippCpsGrid: true }, '', u.pathname + u.search + u.hash);
      } catch (_e) {}
    }

    runSortForWrap(grid);
  }

  function bindCpsGridTabNavigation() {
    document.querySelectorAll('[data-category-product-showcase][data-cps-product-mode="grid"]').forEach(function (sectionEl) {
      if (sectionEl.dataset.cpsGridTabNavBound === '1') return;
      sectionEl.dataset.cpsGridTabNavBound = '1';

      sectionEl.addEventListener(
        'click',
        function (e) {
          var tab = e.target.closest('a.category-product-showcase__tab[data-cps-tab]');
          if (!tab || !sectionEl.contains(tab)) return;
          if (e.defaultPrevented) return;
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          if (typeof e.button === 'number' && e.button !== 0) return;

          var targetId = (tab.getAttribute('data-cps-tab') || '').trim();
          var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
          var currentId = grid ? (grid.getAttribute('data-cps-block-id') || '').trim() : '';
          if (!targetId || targetId === currentId) return;

          e.preventDefault();
          switchCpsGridCollection(sectionEl, targetId, true);
        },
        false
      );
    });
  }

  /**
   * Grid pagination: same-page links only — avoid full reload; pushState + re-slice from cache.
   */
  function bindCpsGridPagination() {
    document.querySelectorAll('[data-category-product-showcase][data-cps-product-mode="grid"]').forEach(function (sectionEl) {
      if (sectionEl.dataset.cpsGridPaginationBound === '1') return;
      sectionEl.dataset.cpsGridPaginationBound = '1';

      sectionEl.addEventListener(
        'click',
        function (e) {
          var a = e.target.closest('.category-product-showcase__pagination a.pagination__item');
          if (!a || !sectionEl.contains(a)) return;
          if (e.defaultPrevented) return;
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          if (typeof e.button === 'number' && e.button !== 0) return;

          var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
          if (!grid) return;

          var href = a.getAttribute('href');
          if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

          var linkUrl;
          try {
            linkUrl = new URL(href, window.location.href);
          } catch (_e) {
            return;
          }

          /**
           * Liquid paginate URLs point at /collections/... while this block lives on /pages/... .
           * Merge only ?page= (and panel key) onto the current page URL so we stay on the curated page.
           */
          var pageRaw = linkUrl.searchParams.get('page');
          var q = new URLSearchParams(window.location.search);
          if (pageRaw != null && pageRaw !== '') {
            var pn = parseInt(pageRaw, 10);
            if (!isNaN(pn) && pn > 1) q.set('page', String(pn));
            else q.delete('page');
          } else {
            var rel = (a.getAttribute('rel') || '').toLowerCase();
            var isPrev =
              rel === 'prev' || a.classList.contains('pagination__item--arrow-prev');
            var isNext =
              rel === 'next' || a.classList.contains('pagination__item--arrow-next');
            if (isPrev) {
              var curPrev = getPageFromUrl();
              if (curPrev <= 2) q.delete('page');
              else q.set('page', String(curPrev - 1));
            } else if (isNext) {
              var curNxt = getPageFromUrl();
              q.set('page', String(curNxt + 1));
            } else {
              var txt = (a.textContent || '').trim();
              if (/^\d+$/.test(txt)) {
                var pLabel = parseInt(txt, 10);
                if (!isNaN(pLabel)) {
                  if (pLabel > 1) q.set('page', String(pLabel));
                  else q.delete('page');
                }
              }
            }
          }

          var qpKey = grid.getAttribute('data-cps-qp-key') || '';
          var panelId = grid.getAttribute('data-cps-block-id') || '';
          var sectionId = grid.getAttribute('data-cps-section-internal-id') || '';
          if (qpKey && panelId) q.set(qpKey, panelId);
          var brands = grid._cpsBrandFilter;
          if (brands === undefined) brands = getCpsBrandsFromUrl(sectionId);
          applyCpsBrandsToUrlParams(q, sectionId, brands);

          e.preventDefault();
          grid.removeAttribute('data-cps-sort-in-flight');
          grid.dataset.cpsScrollAfterPagination = '1';

          try {
            history.pushState(
              { skippCpsGrid: true },
              '',
              window.location.pathname + (q.toString() ? '?' + q.toString() : '') + window.location.hash
            );
          } catch (_e2) {
            return;
          }

          if (tryApplyCpsGridPageOnly(grid)) {
            maybeScrollCpsAfterPagination(grid);
            return;
          }
          runSortForWrap(grid);
        },
        false
      );
    });
  }

  function onCpsGridPopState() {
    alignCpsGridWithUrl();
    document.querySelectorAll('[data-cps-client-sort="true"]').forEach(function (w) {
      var sec = w.closest('[data-category-product-showcase]');
      if (!sec || sec.getAttribute('data-cps-product-mode') !== 'grid') return;
      var sectionId = w.getAttribute('data-cps-section-internal-id') || '';
      w._cpsBrandFilter = getCpsBrandsFromUrl(sectionId);
      syncCpsBrandFilterUi(sec, w._cpsBrandFilter, sec.querySelector('[data-cps-brand-filter-host]') || sec);
      w.dataset.cpsScrollAfterPagination = '1';
      if (tryApplyCpsGridPageOnly(w)) {
        maybeScrollCpsAfterPagination(w);
        return;
      }
      delete w.dataset.cpsScrollAfterPagination;
      delete w.dataset.cpsClientSortDone;
      runSortForWrap(w);
    });
  }

  function init() {
    alignCpsGridWithUrl();
    bindCpsGridTabNavigation();
    bindCpsGridPagination();
    document.querySelectorAll('[data-category-product-showcase]').forEach(function (sectionEl) {
      bindCpsBrandFilter(sectionEl);
      var grid = sectionEl.querySelector('[data-cps-client-sort="true"]');
      if (grid) {
        var sectionId = grid.getAttribute('data-cps-section-internal-id') || '';
        var brandHost = sectionEl.querySelector('[data-cps-brand-filter-host]');
        syncCpsBrandFilterUi(sectionEl, getCpsBrandsFromUrl(sectionId), brandHost || sectionEl);
      }
    });
    document.querySelectorAll('[data-cps-client-sort="true"]').forEach(runSortForWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('popstate', onCpsGridPopState);

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target) return;
    alignCpsGridWithUrl();
    bindCpsGridTabNavigation();
    bindCpsGridPagination();
    var sectionEl = ev.target.querySelector('[data-category-product-showcase]') || ev.target.closest('[data-category-product-showcase]');
    if (sectionEl) {
      delete sectionEl.dataset.cpsBrandFilterBound;
      bindCpsBrandFilter(sectionEl);
    }
    ev.target.querySelectorAll('[data-cps-client-sort="true"]').forEach(function (w) {
      delete w.dataset.cpsClientSortDone;
      runSortForWrap(w);
    });
  });
})();
